import { z } from 'zod';

import { zodStringRequired, zodStringRequiredWithMinMax } from '@/shared/lib/validations';

import {
  docSerialSchema9,
  passportSerialNumberSchema,
  passportSerialNumberSchemaEn,
} from '@/components/Forms/Validation';

import { ServicePaymentDataProps } from './types';

export const servicePaymentDataSchema = z
  .object({
    defraymentService: z.object({}, { message: 'Оберіть послугу' }).required(),
    defraymentSubService: z.any(),

    orgNpu: z.object({}, { message: 'Оберіть орган НПУ' }).required(),
    paymentInfo: z.any(),
    fullName: zodStringRequiredWithMinMax(),
    rnokpp: z.union([
      zodStringRequired.regex(/^[0-9]{10}$/, { message: 'Недопустимий формат' }),
      passportSerialNumberSchema,
      passportSerialNumberSchemaEn,
      docSerialSchema9,
    ]),
  })
  .superRefine((data, ctx) => {
    if (data.defraymentSubService === null) {
      ctx.addIssue({
        code: 'custom',
        message: 'Оберіть підтип послуги',
        path: ['defraymentSubService'],
      });
    }
  });

export type ServicePaymentMergedSchema = ServicePaymentDataProps;
